/* Johns Electrical — Property Packs behaviour.
   Implements BUILD-NOTES.md §3. No dependencies, no build step.

   1. Pack detail — tab switching + #hash deep links
   2. Build your own — state, chips, per-bedroom xN, persistence, summary bar
   3. Request a quote — prefill from the saved list, role chips
*/
(function () {
  'use strict';

  var STORE_KEY = 'johns-byo-v1';

  /* Mirrors data/build-your-own.json. If a category is added there, add it here —
     the quote page has no category DOM to read titles from. */
  var CATEGORIES = {
    kitchen: { title: 'Kitchen & laundry', perBedroom: false },
    living:  { title: 'Living room',       perBedroom: false },
    bedroom: { title: 'Bedrooms',          perBedroom: true  },
    dining:  { title: 'Dining',            perBedroom: false },
    small:   { title: 'Small appliances',  perBedroom: false },
    starter: { title: 'Kitchen starter',   perBedroom: false }
  };

  var PACK_LABELS = {
    kitchen: 'Kitchen', tv: 'TV', furniture: 'Furniture', everything: 'Everything',
    custom: 'Custom'
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function loadState() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || typeof s !== 'object') return null;
      /* picks[k] used to be a single {t,p,u,s} object; it is now an ARRAY of
         {t,p,u,s,q} so one item can carry several models, each with a quantity.
         Normalise old saved lists instead of dropping them. */
      var picks = {};
      if (s.picks && typeof s.picks === 'object') {
        Object.keys(s.picks).forEach(function (k) {
          var v = s.picks[k];
          if (!v) return;
          var arr = Array.isArray(v) ? v : [v];
          arr = arr.filter(function (m) { return m && m.u; }).map(function (m) {
            return { t: m.t, p: m.p, u: m.u, s: m.s, q: (typeof m.q === 'number' && m.q >= 1) ? m.q : 1 };
          });
          if (arr.length) picks[k] = arr;
        });
      }
      return {
        bedrooms: typeof s.bedrooms === 'number' ? s.bedrooms : 2,
        furnishing: s.furnishing || 'Furnished',
        sel: (s.sel && typeof s.sel === 'object') ? s.sel : {},
        qty: (s.qty && typeof s.qty === 'object') ? s.qty : {},
        picks: picks,
        fitted: !!s.fitted
      };
    } catch (e) { return null; }   /* private mode / disabled storage — degrade quietly */
  }

  function saveState(state) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify({
        bedrooms: state.bedrooms,
        furnishing: state.furnishing,
        sel: state.sel,
        qty: state.qty,
        picks: state.picks,
        fitted: state.fitted,
        savedAt: Date.now()
      }));
    } catch (e) { /* nothing we can do; UI still works for this session */ }
  }

  /* ==============================================================
     1. PACK DETAIL — tabs + hash deep links
     ============================================================== */
  function initPacks() {
    var tabs = $$('[data-pack-tab]');
    if (!tabs.length) return;
    var panels = $$('[data-pack-panel]');

    function select(id, updateHash) {
      if (!PACK_LABELS[id]) return false;
      var found = false;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-pack-panel') === id;
        p.hidden = !on;
        if (on) found = true;
      });
      if (!found) return false;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-pack-tab') === id;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
      return true;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        select(t.getAttribute('data-pack-tab'), true);
      });
    });

    window.addEventListener('hashchange', function () {
      select((window.location.hash || '').replace('#', ''), false);
    });

    /* on load: hash wins, otherwise the server-rendered default stays */
    select((window.location.hash || '').replace('#', ''), false);
  }

  /* ==============================================================
     2. BUILD YOUR OWN
     ============================================================== */
  function initByo() {
    var root = $('[data-byo-root]');
    if (!root) return;

    var stored = loadState();
    var state = stored || { bedrooms: 2, furnishing: 'Furnished', sel: {}, qty: {}, picks: {}, fitted: false };
    if (!state.picks) state.picks = {};
    if (!state.qty) state.qty = {};

    /* ---- product picker data (non-agency stock only) ---- */
    var PRODUCTS = null;
    var productsUrl = root.getAttribute('data-products-url');
    var productBase = root.getAttribute('data-product-url-base') || '/products/';

    function money(n) {
      return '£' + Number(n).toFixed(2).replace(/\.00$/, '');
    }

    function loadProducts() {
      if (PRODUCTS || !productsUrl) return Promise.resolve(PRODUCTS);
      return fetch(productsUrl)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { PRODUCTS = (j && j.items) || {}; return PRODUCTS; })
        .catch(function () { PRODUCTS = {}; return PRODUCTS; });
    }

    var bedsOut     = $('[data-beds-value]');
    var fittedBtn   = $('[data-fitted-toggle]');
    var bar         = $('[data-summarybar]');
    var listWrap    = $('[data-summary-list]');
    var rowsEl      = $('[data-summary-rows]');
    var emptyEl     = $('[data-summary-empty]');
    var countEl     = $('[data-summary-count]');
    var toggleBtn   = $('[data-summary-toggle]');
    var clearBtn    = $('[data-summary-clear]');
    var cta         = $('[data-summary-cta]');
    var listOpen    = false;

    function key(cat, item) { return cat + ':' + item; }

    function isPerBedroom(cat) {
      return !!(CATEGORIES[cat] && CATEGORIES[cat].perBedroom);
    }

    function multiplier(cat) {
      return (isPerBedroom(cat) && state.bedrooms > 1) ? state.bedrooms : 0;
    }

    function clampQty(n) { return Math.max(1, Math.min(9, n)); }

    /* how many of an item: sum of its chosen models' quantities, else its own count */
    function itemQty(k) {
      var models = state.picks[k];
      if (models && models.length) {
        return models.reduce(function (a, m) { return a + (m.q || 1); }, 0);
      }
      return clampQty(state.qty[k] || 1);
    }

    /* ---- chips ---- */
    function paintChip(btn) {
      var cat = btn.getAttribute('data-byo-cat');
      var item = btn.getAttribute('data-byo-item');
      var on = !!state.sel[key(cat, item)];
      var label = $('[data-chip-label]', btn);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!label) return;
      var mult = multiplier(cat);
      var q = itemQty(key(cat, item));
      var text = item;
      if (on) text = '✓ ' + text;
      if (on && !mult && q > 1) text += '  · × ' + q;   /* per-bedroom chips keep the room count */
      if (on && mult) text += '  · × ' + mult;
      label.textContent = text;
    }

    function paintAllChips() { $$('[data-byo-item]').forEach(paintChip); }

    /* ---- "Add the lot" / "Clear the lot" ---- */
    function paintAddLot() {
      $$('[data-add-lot]').forEach(function (btn) {
        var cat = btn.getAttribute('data-add-lot');
        var chips = $$('[data-byo-cat="' + cat + '"]');
        var allOn = chips.length > 0 && chips.every(function (c) {
          return !!state.sel[key(cat, c.getAttribute('data-byo-item'))];
        });
        btn.textContent = allOn ? 'Clear the lot' : 'Add the lot';
      });
    }

    /* ---- summary ---- */
    function selectedEntries() {
      var out = [];
      Object.keys(CATEGORIES).forEach(function (cat) {
        $$('[data-byo-cat="' + cat + '"]').forEach(function (c) {
          var item = c.getAttribute('data-byo-item');
          if (state.sel[key(cat, item)]) out.push({ cat: cat, item: item });
        });
      });
      return out;
    }

    function totalCount() {
      /* quantities count; the bedrooms multiplier still doesn't (BUILD-NOTES §3) */
      return selectedEntries().reduce(function (a, e) {
        return a + itemQty(key(e.cat, e.item));
      }, 0) + (state.fitted ? 1 : 0);
    }

    function paintSummary() {
      var entries = selectedEntries();
      var count = totalCount();

      rowsEl.innerHTML = '';

      function addRow(catTitle, label, price, qtyBadge, mult, removeLabel, onRemove) {
        var li = document.createElement('li');
        li.className = 'je-summarybar__row';
        var cat = document.createElement('span');
        cat.className = 'je-summarybar__cat';
        cat.textContent = catTitle;
        li.appendChild(cat);
        var name = document.createElement('span');
        name.className = 'je-summarybar__item';
        name.textContent = label;
        li.appendChild(name);
        if (price != null) {
          var pp = document.createElement('span');
          pp.className = 'je-pick__price';
          pp.textContent = price;
          li.appendChild(pp);
        }
        if (qtyBadge) {
          var qb = document.createElement('span');
          qb.className = 'je-summarybar__mult';
          qb.textContent = qtyBadge;
          li.appendChild(qb);
        }
        if (mult) {
          var m = document.createElement('span');
          m.className = 'je-summarybar__mult';
          m.textContent = '× ' + mult;
          li.appendChild(m);
        }
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'je-linkbtn je-summarybar__x';
        x.textContent = '✕';
        x.setAttribute('aria-label', removeLabel);
        x.addEventListener('click', onRemove);
        li.appendChild(x);
        rowsEl.appendChild(li);
      }

      entries.forEach(function (e) {
        var k = key(e.cat, e.item);
        var catTitle = CATEGORIES[e.cat] ? CATEGORIES[e.cat].title : e.cat;
        var mult = multiplier(e.cat);
        var models = state.picks[k] || [];

        if (models.length) {
          /* one row per chosen model, each with its own quantity */
          models.forEach(function (m) {
            addRow(catTitle, e.item + ' — ' + m.t, money(m.p),
              (m.q || 1) > 1 ? '× ' + m.q : null, mult, 'Remove ' + m.t,
              function () {
                var arr = state.picks[k] || [];
                var idx = arr.indexOf(m);
                if (idx >= 0) arr.splice(idx, 1);
                if (!arr.length) delete state.picks[k];
                commit();
              });
          });
        } else {
          var q = clampQty(state.qty[k] || 1);
          addRow(catTitle, e.item, null, q > 1 ? '× ' + q : null, mult, 'Remove ' + e.item,
            function () {
              delete state.sel[k];
              commit();
            });
        }
      });

      if (state.fitted) {
        var li2 = document.createElement('li');
        li2.className = 'je-summarybar__row';
        var c2 = document.createElement('span');
        c2.className = 'je-summarybar__cat';
        c2.textContent = 'Fitted kitchen';
        var n2 = document.createElement('span');
        n2.className = 'je-summarybar__item';
        n2.textContent = 'A full fitted kitchen — quoted after a look at the room';
        var x2 = document.createElement('button');
        x2.type = 'button';
        x2.className = 'je-linkbtn je-summarybar__x';
        x2.textContent = '✕';
        x2.setAttribute('aria-label', 'Remove the fitted kitchen');
        x2.addEventListener('click', function () { state.fitted = false; commit(); });
        li2.appendChild(c2); li2.appendChild(n2); li2.appendChild(x2);
        rowsEl.appendChild(li2);
      }

      emptyEl.hidden = count > 0;

      if (count === 0) {
        countEl.textContent = 'Nothing picked yet';
        cta.textContent = 'Pick a few things first';
        cta.classList.add('is-disabled');
        cta.setAttribute('aria-disabled', 'true');
        cta.setAttribute('tabindex', '-1');
      } else {
        countEl.textContent = count + (count === 1 ? ' item' : ' items') +
          ' · ' + state.bedrooms + ' bed · ' + state.furnishing.toLowerCase();
        cta.textContent = "That's everything — request a quote";
        cta.classList.remove('is-disabled');
        cta.removeAttribute('aria-disabled');
        cta.removeAttribute('tabindex');
      }

      toggleBtn.textContent = listOpen ? 'Hide the list' : 'See the list';
      listWrap.hidden = !listOpen;
    }

    function paintBeds() {
      if (bedsOut) bedsOut.textContent = state.bedrooms;
      $$('[data-beds]').forEach(function (b) {
        var step = parseInt(b.getAttribute('data-beds'), 10);
        b.disabled = (step < 0 && state.bedrooms <= 1) || (step > 0 && state.bedrooms >= 8);
      });
    }

    function paintFurnishing() {
      $$('[data-furnishing]').forEach(function (b) {
        var on = b.getAttribute('data-furnishing') === state.furnishing;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function paintFitted() {
      if (!fittedBtn) return;
      fittedBtn.classList.toggle('is-on', state.fitted);
      fittedBtn.setAttribute('aria-pressed', state.fitted ? 'true' : 'false');
      fittedBtn.textContent = state.fitted
        ? fittedBtn.getAttribute('data-label-on')
        : fittedBtn.getAttribute('data-label-off');
    }

    /* ---- product picker + quantities ----
       Every ticked item gets a row: how many (×1–9) and — where we stock it — WHICH
       models, several different ones if wanted, each with its own quantity. Items we
       don't stock just get the quantity control. Per-bedroom items count per room. */
    var openPanels = {};   /* keep a model list open across repaints while picking several */

    function qtyStepper(value, suffix, itemLabel, onChange) {
      var wrap = document.createElement('span');
      wrap.className = 'je-pick__qty';
      var st = document.createElement('span');
      st.className = 'je-stepper je-stepper--sm';
      var minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.setAttribute('aria-label', 'Fewer — ' + itemLabel);
      minus.disabled = value <= 1;
      var out = document.createElement('output');
      out.textContent = value;
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'More — ' + itemLabel);
      plus.disabled = value >= 9;
      minus.addEventListener('click', function () { onChange(clampQty(value - 1)); });
      plus.addEventListener('click', function () { onChange(clampQty(value + 1)); });
      st.appendChild(minus);
      st.appendChild(out);
      st.appendChild(plus);
      wrap.appendChild(st);
      if (suffix) {
        var sf = document.createElement('span');
        sf.className = 'je-pick__qtysuffix';
        sf.textContent = suffix;
        wrap.appendChild(sf);
      }
      return wrap;
    }

    function paintPicks() {
      var P = PRODUCTS || {};
      Object.keys(CATEGORIES).forEach(function (cat) {
        var host = $('[data-picks="' + cat + '"]');
        if (!host) return;
        host.innerHTML = '';
        var perBed = isPerBedroom(cat);

        $$('[data-byo-cat="' + cat + '"]').forEach(function (chip) {
          var item = chip.getAttribute('data-byo-item');
          var k = key(cat, item);
          if (!state.sel[k]) return;

          var list = P[k] || [];
          var models = state.picks[k] || [];

          var row = document.createElement('div');
          row.className = 'je-pick';

          var forEl = document.createElement('span');
          forEl.className = 'je-pick__for';
          forEl.textContent = item;
          row.appendChild(forEl);

          /* item-level quantity — once specific models are picked they carry their own */
          if (!models.length) {
            row.appendChild(qtyStepper(
              clampQty(state.qty[k] || 1),
              perBed ? 'each bedroom' : null,
              item,
              function (next) { state.qty[k] = next; commit(); }
            ));
          }

          if (list.length && !models.length) {
            var chosenEl = document.createElement('span');
            chosenEl.className = 'je-pick__chosen';
            chosenEl.textContent = list.length + ' to choose from — pick one or several, or leave it and we\'ll recommend one';
            row.appendChild(chosenEl);
          }

          var toggle = null;
          if (list.length) {
            var actions = document.createElement('span');
            actions.className = 'je-pick__actions';
            toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'je-linkbtn';
            toggle.textContent = openPanels[k] ? 'Close the list'
              : (models.length ? 'Add another model' : 'Choose a model');
            actions.appendChild(toggle);
            row.appendChild(actions);
          }

          /* chosen models, each with its own quantity */
          if (models.length) {
            var chosenList = document.createElement('div');
            chosenList.className = 'je-pickchosen';
            models.forEach(function (m) {
              var line = document.createElement('div');
              line.className = 'je-pickchosen__row';

              var nm = document.createElement('span');
              nm.className = 'je-pickchosen__name';
              nm.textContent = m.t;
              line.appendChild(nm);

              var pr = document.createElement('span');
              pr.className = 'je-pick__price';
              pr.textContent = money(m.p);
              line.appendChild(pr);

              line.appendChild(qtyStepper(m.q || 1, perBed ? 'each bedroom' : null, m.t,
                function (next) { m.q = next; commit(); }));

              var acts = document.createElement('span');
              acts.className = 'je-pickchosen__acts';
              var view = document.createElement('a');
              view.className = 'je-linkbtn';
              view.href = productBase + m.u;
              view.target = '_blank';
              view.rel = 'noopener';
              view.textContent = 'View';
              acts.appendChild(view);
              var rm = document.createElement('button');
              rm.type = 'button';
              rm.className = 'je-linkbtn';
              rm.style.color = 'var(--je-muted)';
              rm.textContent = 'Remove';
              rm.setAttribute('aria-label', 'Remove ' + m.t);
              rm.addEventListener('click', function () {
                var arr = state.picks[k] || [];
                var idx = arr.indexOf(m);
                if (idx >= 0) arr.splice(idx, 1);
                if (!arr.length) delete state.picks[k];
                commit();
              });
              acts.appendChild(rm);
              line.appendChild(acts);

              chosenList.appendChild(line);
            });
            row.appendChild(chosenList);
          }

          /* the full model list — clicking a model toggles it in or out */
          if (list.length) {
            var panel = document.createElement('div');
            panel.className = 'je-pick__list' + (openPanels[k] ? ' is-open' : '');
            list.forEach(function (prod) {
              var inList = models.some(function (m) { return m.u === prod.u; });
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'je-pickrow' + (inList ? ' is-chosen' : '');

              if (prod.i) {
                var im = document.createElement('img');
                im.className = 'je-pickrow__img';
                im.src = prod.i;
                im.alt = '';
                im.loading = 'lazy';
                b.appendChild(im);
              }

              var body = document.createElement('span');
              body.className = 'je-pickrow__body';
              var t = document.createElement('span');
              t.className = 'je-pickrow__title';
              t.textContent = prod.t;
              var meta = document.createElement('span');
              meta.className = 'je-pickrow__meta';
              var dot = document.createElement('span');
              dot.className = 'je-stockdot ' + (prod.s ? 'je-stockdot--in' : 'je-stockdot--order');
              dot.textContent = prod.s ? 'In stock' : 'To order';
              meta.appendChild(dot);
              meta.appendChild(document.createTextNode(' ' + (prod.v || '')));
              body.appendChild(t);
              body.appendChild(meta);
              b.appendChild(body);

              var pr2 = document.createElement('span');
              pr2.className = 'je-pickrow__price';
              pr2.textContent = money(prod.p);
              b.appendChild(pr2);

              b.addEventListener('click', function () {
                var arr = state.picks[k] || (state.picks[k] = []);
                var idx = -1;
                arr.forEach(function (m, i2) { if (m.u === prod.u) idx = i2; });
                if (idx >= 0) { arr.splice(idx, 1); } else { arr.push({ t: prod.t, p: prod.p, u: prod.u, s: prod.s, q: 1 }); }
                if (!arr.length) delete state.picks[k];
                commit();
              });
              panel.appendChild(b);
            });
            row.appendChild(panel);

            toggle.addEventListener('click', function () {
              openPanels[k] = !openPanels[k];
              panel.classList.toggle('is-open', !!openPanels[k]);
              toggle.textContent = openPanels[k] ? 'Close the list'
                : ((state.picks[k] || []).length ? 'Add another model' : 'Choose a model');
            });
          }

          host.appendChild(row);
        });
      });
    }

    /* picks and quantities are meaningless once their item is unticked */
    function prunePicks() {
      Object.keys(state.picks).forEach(function (k) {
        if (!state.sel[k]) delete state.picks[k];
      });
      Object.keys(state.qty).forEach(function (k) {
        if (!state.sel[k]) delete state.qty[k];
      });
    }

    function commit() {
      prunePicks();
      saveState(state);
      paintAllChips();
      paintAddLot();
      paintBeds();
      paintFurnishing();
      paintFitted();
      paintPicks();
      paintSummary();
    }

    /* ---- wiring ---- */
    $$('[data-byo-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-byo-cat');
        var item = btn.getAttribute('data-byo-item');
        var k = key(cat, item);
        if (state.sel[k]) { delete state.sel[k]; } else { state.sel[k] = true; }
        commit();
      });
    });

    $$('[data-add-lot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-add-lot');
        var chips = $$('[data-byo-cat="' + cat + '"]');
        var allOn = chips.length > 0 && chips.every(function (c) {
          return !!state.sel[key(cat, c.getAttribute('data-byo-item'))];
        });
        chips.forEach(function (c) {
          var k = key(cat, c.getAttribute('data-byo-item'));
          if (allOn) { delete state.sel[k]; } else { state.sel[k] = true; }
        });
        commit();
      });
    });

    $$('[data-beds]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-beds'), 10);
        var next = state.bedrooms + step;
        if (next < 1 || next > 8) return;
        state.bedrooms = next;
        commit();
      });
    });

    $$('[data-furnishing]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.furnishing = b.getAttribute('data-furnishing');
        commit();
      });
    });

    if (fittedBtn) {
      fittedBtn.addEventListener('click', function () {
        state.fitted = !state.fitted;
        commit();
      });
    }

    toggleBtn.addEventListener('click', function () {
      listOpen = !listOpen;
      paintSummary();
    });

    clearBtn.addEventListener('click', function () {
      /* clears the LIST (picks, quantities + fitted kitchen); the property scaler is left alone */
      state.sel = {};
      state.qty = {};
      state.fitted = false;
      commit();
    });

    cta.addEventListener('click', function (e) {
      if (cta.classList.contains('is-disabled')) e.preventDefault();
    });

    commit();
    loadProducts().then(paintPicks);   /* pickers appear as soon as the index lands */
  }

  /* ==============================================================
     3. REQUEST A QUOTE — live form + prefill + role chips
     ============================================================== */
  function initQuote() {
    var root = $('[data-quote-root]');
    if (!root) return;

    /* posted OK: the confirmation panel is rendered server-side; the saved list
       has done its job, so clear it rather than re-prefilling a sent request */
    var success = $('[data-quote-success]');
    if (success) {
      try { window.localStorage.removeItem(STORE_KEY); } catch (e) { /* fine */ }
      success.focus();
      return;
    }

    /* role chips: single-select, mirrored into the hidden contact[You are] field */
    var roleGroup = $('[data-role-group]');
    var roleInput = $('[data-role-input]');
    if (roleGroup) {
      $$('[data-role]', roleGroup).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-role]', roleGroup).forEach(function (o) {
            o.classList.toggle('is-on', o === b);
            o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
          });
          if (roleInput) roleInput.value = b.getAttribute('data-role');
        });
      });
    }

    /* live form: paint invalid fields (native message still shows), spinner on send */
    var formEl = root.querySelector('form');
    var submitBtn = $('[data-quote-submit]');
    if (formEl) {
      $$('.je-input', formEl).forEach(function (inp) {
        inp.addEventListener('invalid', function () { inp.classList.add('is-error'); });
        inp.addEventListener('input', function () { inp.classList.remove('is-error'); });
      });
      formEl.addEventListener('submit', function () {
        if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.disabled = true; }
      });
    }

    var what = $('[data-quote-what]');
    var help = $('[data-quote-help]');
    var bedsSel = $('[data-quote-beds]');
    if (!what) return;

    var state = loadState();
    var lines = [];

    if (state) {
      Object.keys(CATEGORIES).forEach(function (cat) {
        var items = Object.keys(state.sel || {})
          .filter(function (k) { return k.indexOf(cat + ':') === 0; })
          .map(function (k) { return k.slice(cat.length + 1); });
        if (!items.length) return;
        var title = CATEGORIES[cat].title;
        if (CATEGORIES[cat].perBedroom && state.bedrooms > 1) {
          title += ' (each of ' + state.bedrooms + ' bedrooms)';
        }
        /* name models and quantities where set, so the quote starts from them */
        var labelled = items.map(function (it) {
          var k2 = cat + ':' + it;
          var pk = state.picks && state.picks[k2];
          if (pk && pk.length) {
            var parts = pk.map(function (m) { return ((m.q || 1) > 1 ? m.q + '× ' : '') + m.t; });
            return it + ' (' + parts.join(', ') + ')';
          }
          var q2 = (state.qty && state.qty[k2]) || 1;
          return q2 > 1 ? it + ' ×' + q2 : it;
        });
        lines.push(title + ': ' + labelled.join(', '));
      });
      if (state.fitted) {
        lines.push('Plus: a full fitted kitchen — happy to arrange a look at the room.');
      }
    }

    /* never overwrite text already in the box — e.g. {{ form.body }} restored
       after a failed post, possibly hand-edited before submitting */
    if (lines.length && !what.value) {
      what.value = lines.join('\n');
      if (help) help.textContent = 'Filled in from the list you built. Change anything you like.';
      if (bedsSel && state && state.bedrooms) {
        var target = state.bedrooms >= 5 ? '5+' : String(state.bedrooms);
        $$('option', bedsSel).forEach(function (o) { o.selected = (o.value || o.textContent) === target; });
      }
    } else if (!what.value) {
      /* no saved list — a pack link may still tell us what they were looking at */
      var m = /[?&]pack=([a-z]+)/.exec(window.location.search);
      if (m && PACK_LABELS[m[1]]) {
        what.value = 'The ' + PACK_LABELS[m[1]] + ' pack.';
        if (help) help.textContent = 'Filled in from the pack you were looking at. Change anything you like.';
      }
      /* otherwise the placeholder stands — BUILD-NOTES §3 */
    }
  }

  function init() { initPacks(); initByo(); initQuote(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
